var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"largeBtn",attrs:{"type":"warning","loading":_vm.exportBtn.loading},on:{"click":_vm.exportMeth}},[_vm._v(_vm._s(_vm.textProp))])
}
var staticRenderFns = []

export { render, staticRenderFns }